import { Paper } from '@mantine/core';
import { cn } from '@/utils';

interface SummaryCardProps {
    className?: string;
    children: React.ReactNode;
}

const SummaryCard = ({ children, className }: SummaryCardProps) => {
    return (
        <Paper
            className={cn('bg-white p-6 flex flex-col gap-6', className)}
            radius="md"
        >
            {children}
        </Paper>
    );
};

export default SummaryCard;
